import { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import { Plus, Trash2 } from "lucide-react";
import { formatCurrency } from "../../util";

const BudgetInputTable = ({
  control,
  register,
  errors,
  watch,
  name,
  label,
  categories = [],
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });
  const items = watch(name) || [];
  const totalArray = items.map((item) => item.amount * item.quantity);

  useEffect(() => {
    watch(fields.map((_, index) => `${name}.[${index}].amount`));
    watch(fields.map((_, index) => `${name}.[${index}].quantity`));
    watch(fields.map((_, index) => `${name}.[${index}].total`));
  }, [name, fields, items, watch]);

  // Handle quantity and amount changes
  useEffect(() => {
    fields.forEach((_, index) => {
      setValue(
        `${name}[${index}].total`,
        items[index]?.quantity || 0 * items[index]?.amount || 0
      );
    });
  }, [items, fields, name, setValue]);

  useEffect(() => {}, [categories]);

  return (
    <div className="mb-10 w-full overflow-x-hidden">
      <div className="flex items-center justify-between">
        <label className="mb-2 text-text-1/90 font-medium">{label}</label>
        <button
          type="button"
          onClick={
            () =>
              append({
                id: null,
                account_id: null,
                name: "",
                quantity: 1,
                amount: 0,
                total: 0,
              }) // Add new empty item
          }
          className="bg-primary text-white p-1 rounded"
        >
          <Plus size={15} className="text-text-gen" />
        </button>
      </div>

      {/* Table Communication */}
      {items && (
        <div className=" overflow-x-auto">
          <div className="table-container">
            <table>
              <thead>
                <tr className="bg-bkg">
                  <td className="p-1 py-2 bg-gray-600 text-text-gen ">No</td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen ">
                    Description
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen text-center">
                    Sub Category
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen text-center">
                    Qty
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen text-center">
                    Unit Price
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen  text-right">
                    Total
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen ">
                    Action
                  </td>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={index}>
                    <td className="p-1">{index + 1}</td>
                    <td className="p-1">
                      <div className="invisible">
                        <input
                          type="hidden"
                          defaultValue={field.value}
                          {...register(`${name}.[${index}].id`)}
                        />
                        <input
                          type="hidden"
                          defaultValue={field.value}
                          {...register(`${name}.[${index}].account_id`)}
                        />
                      </div>

                      <input
                        type="text"
                        defaultValue={field.value}
                        className="focus:outline-primary p-0.5 mx-1 bg-transparent hover:bg-text-bkg2"
                        {...register(`${name}.[${index}].name`)}
                      />
                    </td>
                    <td>
                      <select
                        className="bg-bkg2"
                        {...register(`${name}.[${index}].sub_category_id`, {})}
                      >
                        <option value={null || ""} key={100}>
                          --Select Sub category
                        </option>
                        {categories.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="p-1 text-center">
                      <input
                        type="number"
                        defaultValue={field.value}
                        className="focus:outline-primary p-0.5 mx-1 text-center bg-transparent max-w-20 hover:bg-text-bkg2"
                        min={0}
                        {...register(`${name}.[${index}].quantity`, {
                          valueAsNumber: true,
                        })}
                      />
                    </td>
                    <td className="p-1  text-center">
                      <input
                        type="number"
                        defaultValue={field.valuue}
                        className="focus:outline-primary p-0.5 mx-1 bg-transparent hover:bg-text-bkg2 text-right max-w-20"
                        min={0}
                        step={0.01}
                        {...register(`${name}.[${index}].amount`, {
                          valueAsNumber: true,
                        })}
                      />
                    </td>
                    <td className="p-1 text-right">
                      {formatCurrency(
                        (items[index]?.amount || 0) *
                          (items[index]?.quantity || 0)
                      )}
                    </td>
                    <td className="p-1  text-right">
                      <button
                        type="button"
                        onClick={() => remove(index)}
                        className="text-red-500 px-2 py-1 rounded "
                      >
                        <Trash2 size={15} />
                      </button>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td className="font-bold text-base" colSpan={5}>
                    Total
                  </td>
                  <td className="font-bold text-base text-right">
                    {formatCurrency(
                      totalArray.reduce((acc, item) => item + acc, 0)
                    )}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            {/* Error */}
            {errors && errors.root && (
              <p className="text-red-400 text-xs text-wrap ">
                {errors.root.message}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetInputTable;
